module.exports = __webpack_public_path__ + "img/3-2.43f8ca20.svg";